import { lazyRoute, preloadLazyRoute } from "utils/lazyRoute";

const adminImport = () => import("layouts/Admin");

export const LazyAdmin = lazyRoute(adminImport);
LazyAdmin.displayName = "Admin";

export const preloadAdmin = () => preloadLazyRoute(adminImport);
